import { render, staticRenderFns } from "./OrticButton.vue?vue&type=template&id=1aa8eaa6&"
import script from "./OrticButton.vue?vue&type=script&lang=js&"
export * from "./OrticButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports